const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const NormativGrid = [
    { field: 'id', headerName: '#', width: 60, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'name', headerName: 'Emertimi', width: 515, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'unit', headerName: 'Njesia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'articleType', headerName: 'Lloji artikullit', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false }
]

export const gridHeader = [
    { field: 'id', headerName: '#', width: 60, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', minWidth: 130, flex: 0.9, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'name', headerName: 'Emertimi', minWidth: 260, flex: 1.8, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'unit', headerName: 'Njesia', minWidth: 110, flex: 0.8, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'qty', headerName: 'Sasia', minWidth: 110, flex: 0.8, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
]